import React, { useEffect } from "react";
// 引入 AOS 動畫庫與其樣式，用以實現頁面元素的進場動效
import Aos from "aos";
import "aos/dist/aos.css";
// 引入本元件的 CSS 樣式
import "./signature.css";
// 引入 React Router 的 Link，用於頁面導覽
import { Link } from "react-router-dom";

// 引入圖示
import { HiOutlineLocationMarker } from "react-icons/hi";

// 引入圖片資源
import img5 from "../../Assets/signImg/img5.jpeg";

/*
  Data 陣列：
  - 儲存此行程頁面所需的主要資訊，包括圖片、行程標題、地點、執行機構、費用與描述等。
  - 若需擴充更多行程，只需在此陣列中新增相應物件即可。
*/
const Data = [
  {
    id: 5,
    imgSrc: img5,
    destTitle: "運籌帷幄 - 金融精英美國晉級之旅",
    location: "🇺🇸 · 美國 · 東海岸",
    grade: "16-28 歲",
    fees: "3900 美元",
    description:
      "全球頂級商學院，90%在美國；全球最高經濟學獎得主，90%在美國；全球最好的資本市場、投資機構亦在美國……來最好的課堂，聽一聽，資本市場如何壯大文明。",
  },
];

/*
  Signature5 元件：
  - 利用 useEffect 初始化 AOS 動畫庫，設定動畫持續時間為 2000 毫秒。
  - 透過 Data 陣列動態渲染行程資訊，包含行程特色、參團資訊、參考行程等詳細資料。
  - 使用表格呈現各項資訊，並提供返回首頁及報名連結。
  - 全部文字內容皆依臺灣用語習慣轉為繁體中文。
*/
export default function Signature5() {
  // 在元件掛載時初始化 AOS 動畫效果
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區塊 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          運 籌 帷 幄 - 金 融 精 英 美 國 晉 級 之 旅
        </h3>
        <button className="signHomeBtn">
          <Link to="/" className="signHomeBtnLink">
            返回首頁
          </Link>
        </button>
      </div>

      {/* 主要內容區：採用 Grid 佈局 */}
      <div className="signSecContent signGrid">
        {Data.map(({ id, imgSrc, destTitle, location, company, fees, description }) => {
          return (
            <div key={id} data-aos="fade-up" className="signSingleDestination">
              {/* 左側文字資訊區 */}
              <div className="signCardInfo">
                <h4 className="signDestTitle">{destTitle}</h4>
                {/* 地點資訊，搭配圖示 */}
                <span className="signContinent signFlex">
                  <HiOutlineLocationMarker className="icon" />
                  <span className="signName">{location}</span>
                </span>

                {/* 行程特色與詳細描述區 */}
                <div className="signFees signFlex">
                  <div className="signGrade">
                    <span>
                      執行機構：{company}
                      <br /><br />
                      <small>⭐️ 行 程 精 華 ⭐️</small>
                      <br /><br />
                    </span>
                  </div>
                  <div>
                    <h6>{description}</h6>
                    <br />
                    {/* 表格展示活動亮點 */}
                    <table width="80%">
                      <thead>
                        <tr>
                          <th width="20%"></th>
                          <th width="10%"></th>
                          <th width="70%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>活動亮點</td>
                          <td></td>
                          <td>
                            藤校商學院課程、紐約證券交易所 VIP 講座；銀行財閥、資產管理銀行、頂級投行參訪
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>密集學習</td>
                          <td></td>
                          <td>
                            9 日行程包含 6 所頂級商學院/管理學院全套資產管理、投資、銀行課程；考察 6 所頂級藤校 / 大學；參觀三所銀行、投行、證交所，一場證券 VIP 講座；紐約曼哈頓自由行；奧特萊斯的瘋狂採購
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <td>未來規劃</td>
                          <td></td>
                          <td>考察東部 6 所大學，完成個人未來規劃</td>
                        </tr>
                        <br />
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* 參團資訊區 */}
                <div className="signFees signFlex">
                  <div className="signGrade">
                    <span>
                      <small>⭐️ 參 團 資 訊 ⭐️</small>
                    </span>
                    <br /><br />
                  </div>
                  <br />
                  <table width="70%">
                    <thead>
                      <tr>
                        <th width="20%"></th>
                        <th width="10%"></th>
                        <th width="70%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>招生對象</td>
                        <td></td>
                        <td>16-28 歲學生、MBA、EMBA，從業者</td>
                      </tr>
                      <tr>
                        <td>時 間</td>
                        <td></td>
                        <td>2024 年 8 月 10 日-18 日</td>
                      </tr>
                      <tr>
                        <td>時 長</td>
                        <td></td>
                        <td>9 天</td>
                      </tr>
                      <tr>
                        <td>地 點</td>
                        <td></td>
                        <td>美國 · 東海岸</td>
                      </tr>
                      <tr>
                        <td>費 用 包 括</td>
                        <td></td>
                        <td>課程費用、講座費用、交通費用、集體活動時的三餐、住宿</td>
                      </tr>
                      <tr>
                        <td>費 用 不 包 括</td>
                        <td></td>
                        <td>簽證手續費、國際旅費、個人消費、自由活動時的所有開銷</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* 參考行程區塊 */}
                <div className="signFees">
                  <div className="signGrade">
                    <span>
                      <small>⭐️ 參 考 行 程 ⭐️</small>
                    </span>
                    <br /><br />
                  </div>
                  <br />
                  <h6>行程範例</h6>
                  <p>
                    實際活動內容可能會有前後調整；或被相近內容替代；夏校正式開始前一週確定具體行程。
                  </p>
                  <br />
                  <table width="100%">
                    <thead>
                      <tr>
                        <th width="5%">日期</th>
                        <th width="12.5%">上午</th>
                        <th width="32.5%">活動</th>
                        <th width="5%"></th>
                        <th width="12.5%">下午</th>
                        <th width="32.5%">活動</th>
                      </tr>
                      <br />
                    </thead>
                    <tbody>
                      <tr>
                        <td>週六</td>
                        <td>出發</td>
                        <td>抵達</td>
                        <td></td>
                        <td>入住</td>
                        <td>休整</td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週日</td>
                        <td>曼哈頓自由行</td>
                        <td>曼哈頓自由行</td>
                        <td></td>
                        <td>曼哈頓自由行</td>
                        <td>曼哈頓自由行</td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週一</td>
                        <td>
                          哥倫比亞大學商學院：<br />《銀行業基礎概論》
                        </td>
                        <td>
                          <tr>1、理解銀行業的基本概念及歷史發展；</tr>
                          <tr>2、探討不同類型銀行機構及其功能：商業銀行、投資銀行、中央銀行等；</tr>
                          <tr>3、學習銀行業主要服務及產品：存款、貸款、支付結算、信用卡等；</tr>
                          <tr>4、分析銀行業監管環境與法規要求；</tr>
                        </td>
                        <td></td>
                        <td>
                          參訪紐約證券交易所：<br />講座《證券市場概論》<br />
                          <br />Go to The Wharton School
                        </td>
                        <td>
                          <tr>1、金融市場及證券交易；</tr>
                          <tr>2、投資組合管理；</tr>
                          <tr>3、交易策略與風險控制；</tr>
                          <tr>4、交易平台與工具；</tr>
                        </td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週二</td>
                        <td>
                          賓夕法尼亞大學<br />沃頓商學院：<br />《資產管理基礎知識》
                        </td>
                        <td>
                          <tr>1、介紹資產管理的概念及作用；</tr>
                          <tr>2、學習資產管理目標與流程：資產配置、風險管理、績效評估等；</tr>
                          <tr>3、探討不同類型資產管理機構及產品：投資基金、資產管理公司、財富管理等；</tr>
                          <tr>4、分析資產管理行業發展趨勢及挑戰；</tr>
                        </td>
                        <td></td>
                        <td>
                          拜訪沃頓商學院<br />
                          <br />Go to Boston MA
                        </td>
                        <td>
                          <tr>1、校園；</tr>
                          <tr>2、教舍；</tr>
                          <tr>3、學制；</tr>
                          <tr>4、留學；</tr>
                        </td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週三</td>
                        <td>
                          哈佛大學商學院：<br />《風險投資入門》
                        </td>
                        <td>
                          <tr>1、理解風險投資的定義及基本原理；</tr>
                          <tr>2、探討風險投資主要形式及流程：天使投資、風險投資基金、私募股權等；</tr>
                          <tr>3、學習風險投資投資決策流程及方法：盡職調查、投後管理、退出策略等；</tr>
                          <tr>4、分析風險投資在創業企業與創新產業中的作用及影響；</tr>
                        </td>
                        <td></td>
                        <td>
                          拜訪哈佛大學商學院<br />
                          <br />拜訪風險投資公司
                        </td>
                        <td>
                          <tr>1、公司介紹；</tr>
                          <tr>2、業務介紹；</tr>
                          <tr>3、行業介紹；</tr>
                          <tr>4、參觀公司；</tr>
                        </td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週四</td>
                        <td>
                          麻省理工大學<br />斯隆管理學院：<br />《銀行風險管理與監管》
                        </td>
                        <td>
                          <tr>1、介紹銀行業面臨的不同類型風險：信用風險、市場風險、操作風險等；</tr>
                          <tr>2、學習銀行風險管理方法及工具：壓力測試、資本充足性、風險評估模型等；</tr>
                          <tr>3、探討銀行業監管機構及法規要求：央行監管、存款保險、金融穩定委員會等；</tr>
                          <tr>4、分析銀行業風險管理最佳實踐及挑戰；</tr>
                        </td>
                        <td></td>
                        <td>
                          拜訪斯隆管理學院<br />
                          <br />拜訪商業銀行<br />
                          <br />Go to The Brown University
                        </td>
                        <td>
                          <tr>1、公司介紹；</tr>
                          <tr>2、業務介紹；</tr>
                          <tr>3、行業介紹；</tr>
                          <tr>4、參觀公司；</tr>
                        </td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週五</td>
                        <td>
                          布朗大學商學院：<br />《資產管理策略與實踐》
                        </td>
                        <td>
                          <tr>1、理解資產管理策略選擇及實施方法；</tr>
                          <tr>2、學習資產配置的重要性及方法：資產類別選擇、風險控制、投資組合優化等；</tr>
                          <tr>3、探討不同投資策略特點及風險收益特性：價值投資、成長投資、定量投資等；</tr>
                          <tr>4、分析資產管理實踐中的成功案例與經驗教訓；</tr>
                        </td>
                        <td></td>
                        <td>
                          耶魯大學管理學院：<br />《風險投資與創業生態系統》
                        </td>
                        <td>
                          <tr>1、探討風險投資在創業生態系統中的作用與意義；</tr>
                          <tr>2、分析風險投資的投資標的及領域：科技創新、生物醫藥、清潔能源等；</tr>
                          <tr>3、學習創業企業的融資管道與策略：天使投資、種子輪融資、A 輪融資等；</tr>
                          <tr>4、總結課程學習成果，展望銀行、資產管理與風險投資未來發展趨勢；</tr>
                        </td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週六</td>
                        <td>瘋狂奧特萊斯</td>
                        <td>奧特萊斯購物</td>
                        <td></td>
                        <td>曼哈頓自由行</td>
                        <td>曼哈頓自由行</td>
                      </tr>
                      <br /><br />
                      <tr>
                        <td>週日</td>
                        <td>返程</td>
                        <td>返程</td>
                        <td></td>
                        <td>順利抵達</td>
                        <td>順利抵達</td>
                      </tr>
                      <br /><br />
                    </tbody>
                  </table>
                </div>

                {/* 預售價格與報名按鈕區 */}
                <div className="signPrice">
                  <h5>預售價格 ：{fees}</h5>
                </div>
                <button className="signBtn signFees">
                  <Link to={"/formReg"} target="_blank">
                    <h4>
                      ⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️
                    </h4>
                  </Link>
                </button>
              </div>

              {/* 右側圖片區塊 */}
              <div className="signImageDiv">
                <img src={imgSrc} alt={destTitle} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}